import { createContext, useContext, useState } from 'react';

import type { LeadDataResponse } from '@widget/api/types';
import type React from 'react';
import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

export type LeadData = (LeadDataResponse & { isNewAppointment?: boolean }) | null;

type LeadError = null | Record<string, any>;

export type LeadDataContextType = {
  leadData: LeadData;
  setLeadData: (leadData: LeadData) => void;
  leadError: LeadError;
  setLeadError: React.Dispatch<LeadError | null>;
  loadingLead: boolean;
  setLoadingLead: React.Dispatch<boolean>;
};

const LeadDataContext = createContext<LeadDataContextType | null>(null);

export const LeadDataProvider: ReactFCWithChildren<any> = ({ children }) => {
  const [leadData, setLeadData] = useState<LeadData>({} as LeadData);
  const [leadError, setLeadError] = useState<null | LeadError>(null);
  const [loadingLead, setLoadingLead] = useState(false);
  return (
    <LeadDataContext.Provider
      value={{ leadData, setLeadData, leadError, setLeadError, loadingLead, setLoadingLead }}
    >
      {children}
    </LeadDataContext.Provider>
  );
};

export const useLeadData = (): LeadDataContextType => {
  const leadDataContext = useContext(LeadDataContext);

  if (leadDataContext === null) {
    throw new Error('The useLeadData hook must be used within the leadDataContext provider');
  }

  return leadDataContext;
};
